import { Clientes } from "./cliente";
import { Factura } from "./Factura";

export class cxcRetencion {
    id: number;
    fecha: string;
    id_emisor: number;
    id_factura: number;
    valor_iva: number;
    sub_total_factura:number;
    iva_factura:number;
    valor_renta: number;
    porcentaje_iva: number;
    porcentaje_renta: number;
    codigo_iva: string;
    codigo_renta: string;
    documento_retencion:string;
    autorizacion_retencion:string;
    factura:Factura;
    cliente:Clientes;
    estado:string;
    numeroDocumento:string;
    valor:number
    tipoDoc:string;
    }
    